<template>
    <div class="container mt-3" style="text-align: center;">
        <div class="months-row">
            <div class="month-col" v-for="s in seriesNames" :key="s.series">
                <month-usage 
                    :series="s"
                    :index="s.index"
                    :this-month="seriesData[s].thisMonth"
                    :last-month="seriesData[s].lastMonth"
                    :this-month-label="seriesData[s].thisMonthLabel"
                    :last-month-label="seriesData[s].lastMonthLabel"
                    :this-month-avg="seriesData[s].thisMonthAvg"
                    :last-month-avg="seriesData[s].lastMonthAvg"
                    :chart-data="seriesData[s].chartData"
                    :chart-period-label="seriesData[s].chartPeriodLabel"
                    @period-change="periodChange"
                    @previous-period="prevPeriod"
                    @next-period="nextPeriod"
                />
            </div>
        </div>
    </div>
</template>

<script>
import readingsService from '@/services/readingsService'
import MonthUsage from '@/components/MonthUsage.vue'
import seriesHelpers from '@/helpers/seriesHelpers'
import dateTime from '@/helpers/dateTime'

export default {
    components: { MonthUsage },
    data() {
        return {
            apartmentId: 0,
            seriesNames: [],
            seriesData: {},
            seriesLabels: {
                'cold_water.volume': 'Kallvatten',
                'hot_water.volume': 'Varmvatten',
                'heat.energy': 'Värmeenergi',
                'heat.volume': 'Hetvatten',
                'electricity.energy': 'Elektricitet',
                'hca.count': 'Radiator',
                'cold.energy': 'Kyl-energi',
            },
        }
    },
    methods: {
        async prevPeriod(series) {
            if (this.seriesData[series].chartIntervalPeriod === 'daysWeek') {
                this.seriesData[series].date.setDate(this.seriesData[series].date.getDate() - 7)
            } else {
                this.seriesData[series].date.setFullYear(this.seriesData[series].date.getFullYear() - 1)
            }
            this.updateSeriesChartData(series)
        },
        async nextPeriod(series) {
            const date = new Date(this.seriesData[series].date)
            if (this.seriesData[series].chartIntervalPeriod === 'daysWeek') {
                date.setDate(this.seriesData[series].date.getDate() + 7)
            } else {
                date.setFullYear(this.seriesData[series].date.getFullYear() + 1)
            }
            if (date > new Date()) {
                return
            }
            this.seriesData[series].date = date
            this.updateSeriesChartData(series)
        },
        async periodChange(options) {
            console.log('periodChange', options)
            
            this.seriesData[options.series].date = new Date()
            // if (options.period === 'monthsYear') {
            //     const now = new Date()
            //     this.seriesData[options.series].date = new Date(now.getFullYear(), 0, 1)
            // } else {
            //     this.seriesData[options.series].date = dateTime.monday(new Date())
            // }

            this.seriesData[options.series].chartIntervalPeriod = options.period
            this.updateSeriesChartData(options.series)
        },
        async updateSeriesChartData(series) {
            const res = (await readingsService.getApartmentChartStatistics(this.$route.params.id, {
                period: this.seriesData[series].chartIntervalPeriod,
                start: this.seriesData[series].date,
                series: series,
            })).data

            let labels = []
            if (res[series].interval === 'month') {
                labels = dateTime.getMonthNames()
            } else {
                labels = [ 'mån', 'tis', 'ons', 'tor', 'fre', 'lör', 'sön' ]
            }

            this.seriesData[series].chartData = {
                labels,
                datasets: [{
                    label: res[series].interval === 'day' ? 'vecka ' + dateTime.getWeekNumber(new Date(res[series].thisPeriodStart)) : dateTime.getMonthString(new Date(res[series].thisPeriodStart)),
                    backgroundColor: seriesHelpers.getColor(series),
                    data: res[series].thisPeriod
                }]
            }
            this.seriesData[series].chartPeriodLabel = res[series].interval === 'day' ? 'vecka ' + dateTime.getWeekNumber(new Date(res[series].thisPeriodStart)) + ', ' + new Date(res[series].thisPeriodStart).getFullYear() : new Date(res[series].thisPeriodStart).getFullYear().toString()
        },
    },
    async mounted() {
        this.apartmentId = this.$route.params.id
        const res = (await readingsService.getApartmentMonthStatistics(this.apartmentId)).data
        const seriesNames = []
        const seriesData = {}
        let index = 0

        for (const s in res) {
            seriesNames.push(s)
            seriesData[s] = {
                series: s,
                index: index++,
                lastMonth: res[s].lastMonth ? seriesHelpers.formatSeriesValue(s, res[s].lastMonth) : '-',
                thisMonth: res[s].thisMonth ? seriesHelpers.formatSeriesValue(s, res[s].thisMonth) : '-',
                lastMonthLabel: dateTime.getLongMonthString(new Date().getMonth() - 1) + ' ' + new Date().getFullYear(),
                thisMonthLabel: dateTime.getLongMonthString(new Date().getMonth()) + ' ' + new Date().getFullYear(),
                lastMonthAvg: res[s].lastMonthAvg ? seriesHelpers.formatSeriesValue(s, res[s].lastMonthAvg) : '-',
                thisMonthAvg: res[s].thisMonthAvg ? seriesHelpers.formatSeriesValue(s, res[s].thisMonthAvg) : '-',
                chartIntervalPeriod: 'daysWeek',
                date: new Date(),
                chartData: { labels: [], datasets: [] }
            }
        }

        this.seriesData = seriesData
        this.seriesNames = seriesNames

        for (const s of seriesNames) {
            await this.updateSeriesChartData(s)
        }
   }
}
</script>

<style>
.months-row {
    display: inline-block;
    text-align: center;
}
.month-col {
    float: left;
}
</style>